import {Box, Button, Grid, LinearProgress, Menu, MenuItem, Select, Typography} from '@mui/material'
import {CurriculoContainer} from '../../components/CurriculoContainer'
import React, { useEffect, useState } from 'react'
import {useAvaliarCandidatoMutation, useAvaliarPreRequisitosInscricoesMutation, useReavaliarPreRequisitosInscricaoMutation} from 'shared/features/api/avaliacao/avaliacaoSlice'
import {useLocation, useNavigate} from 'react-router-dom'
import {toast} from 'react-toastify'
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import {useDeleteInscricaoMutation, useGetInscricaoByIdQuery} from "../../shared/features/api/inscricao/inscricaoSlice";
import { IAvaliarPreRequisitosInterface } from 'shared/features/api/avaliacao/type'
import { DeleteModal } from 'components/DeleteModal'


export const CandidatesCurriculum = () => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
  const [deletarInscricao, {isLoading: carregandoDeleteInscricao}] = useDeleteInscricaoMutation();
  const {state} = useLocation()
  const {data: inscricao, isLoading: carregandoInscricao, isError: inscricaoNaoEncontrada} = useGetInscricaoByIdQuery(state.id);

  const [open, setOpen] = useState<boolean>(false);

  const navigate = useNavigate()

  const handleClickExcluir = async () => {
    setOpen(true)
    await toast.promise(
      deletarInscricao(state.id)
        .unwrap()
        .then(() => {
          navigate('/candidatos')
        }),
      {
        pending: 'Carregando...',
        success: 'Candidato excluido com sucesso!',
         error: {
          render({ data }) {
            const message = (data as { data?: { message?: string } })?.data?.message;
            return message || "Erro ao excluir inscrição.";
          },
        }
      }
    )
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <>
      <Grid container spacing={2}>
        {carregandoInscricao ? (
          <Grid item xs={12}>
            <LinearProgress />
          </Grid>
        ) : inscricaoNaoEncontrada ? (
          <Grid item xs={12}>
            <Typography
              variant="caption"
              fontSize={18}
              sx={{ textAlign: 'center' }}
            >
              Inscrição não encontrada!
            </Typography>
          </Grid>
        ) : (
          <>
            <Grid
              item
              xs={12}
              sx={{
                mb: 2,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
                flexDirection: { xs: "row", sm: "row" },
                gap: 2,
                "@media (max-width: 1051px)": {
                    flexDirection: "column",
                    alignItems: "stretch",
                    width: "100%",
                  },
              }}
            >
              <Grid
                item
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", sm: "row" },
                  alignItems: "center",
                  gap: 2,
                  width: "100%",
                  "@media (max-width: 1051px)": {
                    flexDirection: "column",
                    alignItems: "stretch",
                    width: "100%",
                  },
                }}
              >
                <Typography variant="caption" fontSize={18} minWidth={163}>
                  Situação Inscrição: {inscricao?.situacao.replace("_", " ")}
                </Typography>
              </Grid>

              <Grid
                item
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  gap: 2,
                  alignItems: "center"
                }}
              >
                <Button
                  sx={{
                    height: "3rem",
                    minWidth: 120,
                    "@media (max-width: 1050px)": { width: "100%" },
                  }}
                  variant="outlined"
                  color="error"
                  onClick={()=> setOpen(true)}
                  disabled={carregandoDeleteInscricao}
                >
                  Excluir
                </Button>
              </Grid>
            </Grid>

            {inscricao && (
              <Grid item xs={12}>
                <CurriculoContainer inscricao={inscricao} />
              </Grid>
            )}
          </>
        )}
      </Grid>
      <DeleteModal 
        title='Deletar inscrição'
        context='Deseja confirmar a deleção da inscrição?'
        deleteFunction={handleClickExcluir}
        open={open}
        setOpen={setOpen}
      />
    </>
  )
}
